import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/guawa";

const liveFeed = [
  { icon: "🔥", text: "短剧现象级出圈，评论区吵翻啦", heat: "2.1亿围观" },
  { icon: "🍜", text: "探店排长队：是味道还是营销？", heat: "1.6亿围观" },
  { icon: "🎧", text: "直播价格战，买到就是赚到吗", heat: "1.2亿围观" },
  { icon: "🌿", text: "公园成为打工人新的情绪出口", heat: "9800万围观" },
  { icon: "🏀", text: "那场逆转的绝杀你还记得吗", heat: "6100万围观" },
  { icon: "🎬", text: "年度名场面：谁是刷屏之王", heat: "5300万围观" },
];

export default function Hero() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIdx((v) => (v + 1) % liveFeed.length);
    }, 2600);
    return () => window.clearInterval(timer);
  }, []);

  const active = liveFeed[idx];

  return (
    <section className="relative overflow-hidden">
      {/* 装饰色块（暖色渐变，非蓝紫） */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -right-24 -top-24 h-96 w-96 rounded-full bg-primary-100/70 blur-3xl"></div>
        <div className="absolute -left-20 bottom-0 h-72 w-72 rounded-full bg-accent-100/70 blur-3xl"></div>
      </div>

      <div className="relative mx-auto grid w-full max-w-7xl items-center gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-[1.1fr_0.9fr]">
        <div className="animate-fadeUp">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-white px-3 py-1.5 text-xs font-medium text-primary-700">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
            </span>
            全网瓜友正在围观 · 已累计 2.4 亿条热议
          </span>

          <h1 className="mt-5 text-3xl font-extrabold leading-tight tracking-tight text-ink-900 md:text-5xl">
            今日曝瓜
            <span className="mt-1 block text-2xl font-bold text-primary-600 md:text-4xl">
              吃瓜群众聚集地，看透每一个热点
            </span>
          </h1>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-ink-500 md:text-lg">
            评论区瓜友热议、爆料投稿、在线围观……把散落的热点事件收拢到一个围观现场。来聊聊你的看法，做最清醒的吃瓜群众。
          </p>

          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#site-topics"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600 whitespace-nowrap"
            >
              <i className="ri-fire-line text-lg"></i> 围观今日热点
            </a>
            <Link
              to="/topics"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-cream-300 bg-white px-5 py-3 text-sm font-semibold text-ink-700 transition-colors hover:border-primary-300 hover:text-primary-700 whitespace-nowrap"
            >
              逛热议专区 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* 分类快速入口 */}
          <div className="mt-7 flex flex-wrap items-center gap-2">
            <span className="text-xs font-medium text-ink-400">热门分类：</span>
            {categories.slice(0, 6).map((c) => (
              <a
                key={c.id}
                href="#site-topics"
                className="inline-flex items-center gap-1 rounded-full bg-white px-3 py-1.5 text-xs font-medium text-ink-600 transition-colors hover:bg-primary-50 hover:text-primary-700 whitespace-nowrap"
              >
                <i className={`${c.icon} text-primary-500`}></i> {c.name}
              </a>
            ))}
          </div>
        </div>

        {/* 右侧围观现场面板 */}
        <div className="relative mx-auto w-full max-w-md lg:max-w-none">
          <div className="relative rounded-3xl border border-cream-200 bg-white/80 p-6 shadow-soft backdrop-blur animate-floaty">
            <div className="flex items-center justify-between">
              <h2 className="flex items-center gap-2 text-sm font-bold text-ink-900">
                <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className="ri-eye-2-line"></i>
                </span>
                围观现场 · 实时热议
              </h2>
              <span className="flex items-center gap-1 rounded-full bg-primary-50 px-2.5 py-1 text-[11px] font-medium text-primary-700">
                <i className="ri-radio-button-line animate-pulse"></i> LIVE
              </span>
            </div>

            <div className="mt-5 min-h-[150px] rounded-2xl bg-cream-100 p-4">
              <div key={idx} className="animate-fadeUp">
                <div className="text-4xl">{active.icon}</div>
                <p className="mt-3 text-base font-semibold leading-snug text-ink-800">{active.text}</p>
                <p className="mt-2 text-xs font-medium text-primary-600">{active.heat}</p>
              </div>
            </div>

            <div className="mt-4 flex items-center justify-between text-xs text-ink-400">
              <span className="flex items-center gap-1">
                <i className="ri-group-line text-primary-500"></i> 瓜友在线
              </span>
              <span className="font-semibold text-ink-700">12,846 位在围观</span>
              <span className="flex items-center gap-1">
                <i className="ri-flashlight-line text-accent-500"></i> 每秒 +23
              </span>
            </div>

            <div className="mt-3 flex gap-1.5">
              {liveFeed.map((_, i) => (
                <button
                  key={i}
                  type="button"
                  onClick={() => setIdx(i)}
                  className={`h-1.5 flex-1 rounded-full transition-colors ${
                    i === idx ? "bg-primary-500" : "bg-cream-200"
                  }`}
                  aria-label={`第 ${i + 1} 条热议`}
                ></button>
              ))}
            </div>
          </div>

          {/* 浮动小标签装饰 */}
          <span className="absolute -right-3 -top-3 hidden rounded-full bg-accent-400 px-3 py-1 text-xs font-bold text-white shadow-lift sm:inline-flex">
            今日新增 186 条热议
          </span>
        </div>
      </div>
    </section>
  );
}